import DashboardDemoPage from './DashboardDemo'

export default DashboardDemoPage
